export default "__VITE_ASSET__SElfLf2f__"